export const USE_MOCK_DATA = process.env.REACT_APP_USE_MOCK === 'true';
export const ALMA_API_URL = process.env.REACT_APP_ALMA_API_URL;
export const AUTHORITY_API_URL = process.env.REACT_APP_AUTHORITY_API_URL;
